<h1 mat-dialog-title t7e="title">Kód: Szerződésen felüli</h1>
<div mat-dialog-content>
  <dl class="ts-info" *ngIf="data">
    <dt t7e="usname">Név</dt>
    <dd>{{ data.usname || '-' }}</dd>
    <dt t7e="role">Munkakör</dt>
    <dd>{{ data.role || '-' }}</dd>
    <dt t7e="startdate">Nap</dt>
    <dd>{{ data.startdate ? (data.startdate | date:DATE_FORMAT) : '-' }}</dd>
    <dt t7e="comment">Megjegyzés</dt>
    <dd>{{ data.comment || '-' }}</dd>
    <dt t7e="otherfee">Szerződésen felüli</dt>
    <dd><b>{{ data.otherfee | number }}</b>&nbsp;<span class="currency">{{ data.currency }}</span></dd>
  </dl>

  <mat-form-field class="form-field" appearance="outline">
    <mat-label t7e="code-otherallowance-label">Kód: Szerződésen felüli</mat-label>
    <input matInput [formControl]="code_other" cdkFocusInitial (focus)="$any($event.target).select()" (keydown.enter)="onConfirmed()">
    <mat-hint t7e="code-otherallowance-hint">Az egyéb szerződésen felüli teljesítések könyvelési kódja(i)</mat-hint>
  </mat-form-field>
</div>
<div mat-dialog-actions [align]="'end'" style="gap: 1rem">
  <button mat-raised-button (click)="onCancelled()">{{ 'cancel' | t7e }}</button>
  <button mat-raised-button color="primary" (click)="onConfirmed()" [disabled]="code_other.invalid">OK</button>
</div>
